import React from "react";
import { useFormContext } from "react-hook-form";
import Freezing from "./ConditioningSubforms/freezing";
import Acidification from "./ConditioningSubforms/acidification";
import Not_applicable from "./ConditioningSubforms/not_applicable";
import Refrigeration from "./ConditioningSubforms/refrigeration";
import Filtration from "./ConditioningSubforms/filtration";
import { MCheckbox, ResponsiveFormContainer } from "@app/components";
import { conditioningTablesDisableFalse } from "@app/utils/tables/conditioning.tables";
import { useSample } from "../../utils/useSample";
import ErrorMessage from "@app/utils/ErrorMessage";

type ConditioningOption =
  | "filtration"
  | "freezing"
  | "refrigeration"
  | "acidification"
  | "not_applicable";

const componentsForm: Record<ConditioningOption, React.ComponentType> = {
  filtration: Filtration,
  freezing: Freezing,
  refrigeration: Refrigeration,
  acidification: Acidification,
  not_applicable: Not_applicable,
};

const Conditioning: React.FC = () => {
  const form = useFormContext();
  const { stateSample } = useSample();
  const conditionSelect = form.watch("category") as ConditioningOption;
  const SelectedComponent = componentsForm[conditionSelect] || null;

  return (
    <>
      {stateSample.management.isSave ? (
        <ResponsiveFormContainer columns={1} mt={1}>
          <MCheckbox
            key={JSON.stringify(form.getValues("category"))}
            name="category"
            options={conditioningTablesDisableFalse || []}
            validation={{ required: "Debe seleccionar al menos una opción" }}
            multiple={false}
            orientation="horizontal"
            columns={5}
          />
          {SelectedComponent && <SelectedComponent />}
        </ResponsiveFormContainer>
      ) : (
        <ErrorMessage />
      )}
    </>
  );
};

export default Conditioning;
